(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    // Remember this voluntary activation for this cart, rather than applying an offer automatically.
  const multibuyStorageKey = 'rr:multibuy:activated-cart';
  const returnUrl = new URL(window.location.href);
  let multibuyActivatedOnReturn = returnUrl.searchParams.get('rr_multibuy') === '1';
  let multibuyReturnCartToken = null;

  if (multibuyActivatedOnReturn) {
    returnUrl.searchParams.delete('rr_multibuy');
    try {
      window.history.replaceState(
        window.history.state,
        '',
        returnUrl.pathname + returnUrl.search + returnUrl.hash
      );
    } catch (error) {
      // The offer still works if this browser doesn't allow URL cleanup.
    }
  }

  class RRVinylUpsell extends HTMLElement {
    connectedCallback() {
      // Horizon can refresh the drawer's contents without replacing this element.
      this.multibuyObserver?.disconnect();
      this.multibuyObserver = new MutationObserver(() => {
        this.setMultibuyReady(this.multibuyReady === true);
      });
      this.multibuyObserver.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden']
      });
      this.onMultibuyCartUpdate ||= (event) => {
        const cart = event.detail?.resource;
        if (Array.isArray(cart?.discount_codes)) {
          // Ignore any older status request still in flight when the cart changed.
          this.multibuyRequestId = (this.multibuyRequestId || 0) + 1;
          this.applyMultibuyCart(cart);
        } else {
          return this.updateMultibuyState();
        }
      };
      this.onMultibuyFocus ||= () => this.updateMultibuyState();
      this.onMultibuyVisibility ||= () => {
        if (!document.hidden) return this.updateMultibuyState();
      };
      document.addEventListener('discount:update', this.onMultibuyCartUpdate);
      document.addEventListener('cart:update', this.onMultibuyCartUpdate);
      document.addEventListener('visibilitychange', this.onMultibuyVisibility);
      window.addEventListener('focus', this.onMultibuyFocus);
      window.addEventListener('pageshow', this.onMultibuyFocus);
      this.updateMultibuyState();
    }

    disconnectedCallback() {
      this.multibuyObserver?.disconnect();
      document.removeEventListener('discount:update', this.onMultibuyCartUpdate);
      document.removeEventListener('cart:update', this.onMultibuyCartUpdate);
      document.removeEventListener('visibilitychange', this.onMultibuyVisibility);
      window.removeEventListener('focus', this.onMultibuyFocus);
      window.removeEventListener('pageshow', this.onMultibuyFocus);
      this.multibuyRequestId = (this.multibuyRequestId || 0) + 1;
    }

    async updateMultibuyState() {
      const requestId = (this.multibuyRequestId || 0) + 1;
      this.multibuyRequestId = requestId;
      // The return marker is added only by the discount button's redirect.
      if (this.multibuyReady === undefined) this.setMultibuyReady(multibuyActivatedOnReturn);

      try {
        const response = await fetch(this.dataset.cartUrl, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (!this.isConnected || requestId !== this.multibuyRequestId) return;
        this.applyMultibuyCart(cart);
      } catch (error) {
        // A failed status check must not interrupt the existing discount link.
      }
    }

    applyMultibuyCart(cart) {
      // Scope fallback activation to this cart, not a future purchase.
      const cartToken = typeof cart.token === 'string' ? cart.token.split('?')[0] : '';
      if (multibuyActivatedOnReturn && cartToken && multibuyReturnCartToken === null) {
        multibuyReturnCartToken = cartToken;
      }
      const activatedForThisCart = multibuyActivatedOnReturn &&
        (!cartToken || cartToken === multibuyReturnCartToken);
      let rememberedForThisCart = false;
      try {
        const savedToken = window.sessionStorage.getItem(multibuyStorageKey);
        rememberedForThisCart = Boolean(cartToken && savedToken === cartToken);
        if (savedToken && cartToken && savedToken !== cartToken) {
          window.sessionStorage.removeItem(multibuyStorageKey);
        }
      } catch (error) {
        // Storage restrictions must never prevent shopping or code activation.
      }

      const codesKnown = Array.isArray(cart.discount_codes);
      const codeInCart = codesKnown && cart.discount_codes.some(
        (discount) => String(discount.code || '').toUpperCase() === 'MULTIBUY'
      );
      // Shopify's current list takes precedence, including an empty list after removal.
      const ready = codesKnown ? codeInCart : (activatedForThisCart || rememberedForThisCart);
      if (codesKnown && !codeInCart) {
        multibuyActivatedOnReturn = false;
        multibuyReturnCartToken = null;
      }

      try {
        if (ready && cartToken) {
          window.sessionStorage.setItem(multibuyStorageKey, cartToken);
        } else if (codesKnown) {
          window.sessionStorage.removeItem(multibuyStorageKey);
        }
      } catch (error) {
        // The normal discount link remains available without browser storage.
      }
      this.setMultibuyReady(ready);
    }

    setMultibuyReady(ready) {
      this.multibuyReady = ready;
      this.querySelectorAll('[data-multibuy-state]').forEach((element) => {
        const hidden = element.dataset.multibuyState !== (ready ? 'ready' : 'offer');
        if (element.hidden !== hidden) element.hidden = hidden;
      });
    }
  }

  if (!customElements.get('rr-vinyl-upsell')) {
    customElements.define('rr-vinyl-upsell', RRVinylUpsell);
  }
  } catch(e) { console.error(e); }
})();

})();
